/* eslint camelcase: 0, no-var: 0 */
/* globals _, Backbone, mixpanel */

import lead_in_report_template from '../templates/lead-in-report.pug';
import lead_in_cta_template from '../templates/lead-in-cta.pug';
import lead_in_view from '../templates/lead-in-view.pug';

const heroImage = require(`../trends2022.png`);

_.namespace(`mp.marketing.trends`, function (ns) {
  'use strict';

  // Order to display reports (use slugs)
  const reportSlugOrder = [
    `iphone_15`,
    `ios_17`,
    `iphone_14`,
    `ios_16`,
    `iphone_13`,
    `ios_15`,
    `iphone_12`,
    `ios_14`,
    `iphone_11`,
    `ios_13`,
    `iphone_Xs`,
    `ios_12`,
    `android_vs_ios`,
    `android_os_adoption`,
    `iphone_models`,
    `android_manufacturer`,
  ];

  ns.LeadinViewer = Backbone.TemplateView.extend({
    className: `lead_in`,

    templates: {
      base: lead_in_view,
      lead_in_report: lead_in_report_template,
      lead_in_cta: lead_in_cta_template,
    },

    initialize() {
      this.on_close(function () {
        // close widgets

        // unbind data
        ns.session.off(null, null, this);
      });

      this.render();
    },

    addCtaOnce() {
      if (!this.hasAddedCTA) {
        this.$el.find(`.trends_links`).append(this.render_template(`lead_in_cta`));
        this.hasAddedCTA = true;
      }
    },

    render() {
      this.render_base_template({heroImage});
      const $trendsLinks = this.$el.find(`.trends_links`);
      const reports = Object.values(ns.reports);
      const sortedVisibleReports = reportSlugOrder
        .map((slug) => reports.find((report) => report.slug === slug))
        .filter((report) => report && (!report.hidden || ns.show_hidden_reports));

      for (const [idx, report] of sortedVisibleReports.entries()) {
        const chartType = report.chart_type;
        const reportIcon = chartType === `bar` ? `bar-graph` : chartType;

        const report_elem = $(
          this.render_template(`lead_in_report`, {
            title: report.nice_name,
            description: report.description,
            reportIcon,
          }),
        );
        report_elem.on(`click`, () => ns.router.goto_report(report.slug));
        $trendsLinks.append(report_elem);
        if (idx + 1 === 9) {
          this.addCtaOnce();
        }
      }
      this.addCtaOnce();

      mixpanel.marketing_trends.track(`Viewed Lead In`);
    },
  });
});
